import React from 'react';

interface StatsProps {
  totalLeads: number;
  vettedCount: number;
  discardedCount: number;
  isResting: boolean;
  catchOfTheDayCount: number;
}

const StatsCards: React.FC<StatsProps> = ({ totalLeads, vettedCount, discardedCount, isResting, catchOfTheDayCount }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
      <div className="bg-black text-white p-6 rounded-xl shadow-xl border-l-4 border-red-600">
        <div className="flex items-center justify-between mb-2">
          <span className="text-gray-500 text-[10px] font-black uppercase tracking-widest">Gross Scanned</span>
          <i className="fa-solid fa-radar text-red-600"></i>
        </div>
        <div className="text-3xl font-black">{totalLeads}</div>
      </div>

      <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200 relative overflow-hidden group">
        <div className="absolute top-0 right-0 w-12 h-12 bg-red-600/5 rounded-bl-full -mr-2 -mt-2"></div>
        <div className="flex items-center justify-between mb-2">
          <span className="text-gray-400 text-[10px] font-black uppercase tracking-widest">Service Gaps</span>
          <i className="fa-solid fa-bolt-lightning text-red-600"></i>
        </div>
        <div className="text-3xl font-black text-black">{catchOfTheDayCount}</div>
      </div>

      <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
        <div className="flex items-center justify-between mb-2">
          <span className="text-gray-400 text-[10px] font-black uppercase tracking-widest">Strike Rate</span>
          <i className="fa-solid fa-crosshairs text-black"></i>
        </div>
        <div className="text-3xl font-black text-black">{totalLeads > 0 ? ((vettedCount / totalLeads) * 100).toFixed(0) : 0}%</div>
      </div>

      <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
        <div className="flex items-center justify-between mb-2">
          <span className="text-gray-400 text-[10px] font-black uppercase tracking-widest">Core Temp</span>
          <div className={`w-2 h-2 rounded-full ${isResting ? 'bg-gray-200' : 'bg-red-600 animate-pulse'}`}></div>
        </div>
        <div className="text-3xl font-black text-black uppercase">{isResting ? 'Cool' : 'Active'}</div>
      </div>
    </div>
  );
};

export default StatsCards;
